// src/Models/clientOrgModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class ClientOrgModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      clientOrgID: data.clientOrgId || data.clientOrgID,
      orgName: data.orgName,
      address: data.address,
      contactEmail: data.contactEmail,
      contactPhone: data.contactPhone,
      status: data.status,
      createdDttm: data.createdDttm,
      lastUpdateDttm: data.lastUpdateDttm,
      lastUpdatedBy: data.lastUpdatedBy,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      clientOrgId: Number(data.clientOrgID || data.clientOrgId || 0),
      orgName: data.orgName || '',
      address: data.address || '',
      contactEmail: data.contactEmail || '',
      contactPhone: data.contactPhone || '',
      status: data.status || 'Active',
      createdDttm: data.createdDttm || new Date().toISOString(),
      lastUpdateDttm: new Date().toISOString(),
      lastUpdatedBy: Number(data.lastUpdatedBy || 1),
    };
  }
}
